import api from "@/api";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    deleteFile: async ({ commit }, uuid) => {
      try {
        await api({ requiresAuth: true }).delete(`/v1/media/${uuid}`);
        commit("setToast", {
          display: true,
          type: "success",
          message: "File deleted successfully.",
        });
      } catch (err) {
        console.error(err);
      }
    },

    renameFile: async ({ commit }, { uuid, name }) => {
      try {
        await api({ requiresAuth: true }).patch(`/v1/media/${uuid}`, {
          file_name: name,
        });
        commit("setToast", {
          display: true,
          type: "success",
          message: "File updated successfully.",
        });
      } catch (err) {
        console.error(err);
      }
    },

    changeFileProperties: async (_, { uuid, isApp, isPrivate }) => {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/media/${uuid}/app/properties`,
          {
            is_private: isPrivate,
            is_app: isApp,
          }
        );
      } catch (err) {
        console.error(err);
      }
    },

    openFile: async (_, file) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          `/v1/media/${file.uuid}`,
          {
            responseType: "blob",
          }
        );

        const mimeType = response.data.type || file.mime_type || 'application/octet-stream';
        const fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: mimeType })
        );

        // Check if it's a viewable file type
        const isViewable = mimeType === "application/pdf" || 
                          mimeType.startsWith("image/");

        if (isViewable) {
          // Open viewable files in new window using iframe to force preview
          const newWindow = window.open('', '_blank');
          if (newWindow) {
            newWindow.document.write(`
              <!DOCTYPE html>
              <html>
                <head>
                  <title>${file.file_name}</title>
                  <style>
                    body { margin: 0; overflow: hidden; }
                    iframe { border: none; width: 100vw; height: 100vh; }
                  </style>
                </head>
                <body>
                  <iframe src="${fileURL}"></iframe>
                </body>
              </html>
            `);
            newWindow.document.close();
          }
        } else {
          // For non-viewable files, download them
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", file.file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          window.URL.revokeObjectURL(fileURL);
        }
      } catch (err) {
        console.error(err);
      }
    },

    downloadFile: async (_, file) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          `/v1/media/${file.uuid}`,
          {
            responseType: "blob",
          }
        );

        const mimeType = response.data.type || file.mime_type || 'application/octet-stream';
        const fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: mimeType })
        );

        // Always download - don't open in browser
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", file.file_name);
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        window.URL.revokeObjectURL(fileURL);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
